import React, { Component } from "react";
import CycleFilterContextProvider from "../overview/context/CycleFilterContext";
import PVAOverviewContextProvider from "../overview/context/PVAOverviewContext";
import OverviewContextProvider from "../overview/context/OverviewContext";
import PVAView from "../overview/PVAView";
import OutboundOverviewView from "./OutboundOverviewView";
import CapabilityContextProvider from "../overview/context/CapabilityContext";
import RouteContextProvider from "../outboundAmzl/context/RouteContextProvider";
import OutboundFilterContextProvider from "../outboundAmzl/context/OutboundFilterContext";
import OverallStatusContextProvider from "../overallstatus/context/OverallStatusContext";
import OverallStatusView from "../overallstatus/OverallStatusView";
import OutboundFilterARV2 from "./OutboundFilterARV2";
import RouteWaveView from "./RouteWaveView";
import OutboundBanner from "../outboundAmzl/OutboundBanner";

class OutboundOverview extends Component {
  render() {
    return (
      <CapabilityContextProvider>
        <OutboundFilterContextProvider>
          <OutboundBanner />
          <CycleFilterContextProvider>
            <OutboundFilterARV2 />
            <PVAOverviewContextProvider>
              <OverviewContextProvider>
                <RouteContextProvider>
                  <OutboundOverviewView />
                  <OverallStatusContextProvider>
                    <OverallStatusView />
                  </OverallStatusContextProvider>
                  <PVAView pva={{ processName: "outbound" }} />
                  <RouteWaveView />
                </RouteContextProvider>
              </OverviewContextProvider>
            </PVAOverviewContextProvider>
          </CycleFilterContextProvider>
        </OutboundFilterContextProvider>
      </CapabilityContextProvider>
    );
  }
}
export default OutboundOverview;



// WEBPACK FOOTER //
// ./src/components/outboundOverview/OutboundOverview.js